<template>
  <main
    :class="{
      'main-content-area': true,
      'custom-background-image': $root.color_schema.site_bg_img,
    }"
    :style="{
      '--bg-image': `url(${$root.color_schema.site_bg_img}) repeat`,
      '--bg-color': $root.color_schema.site_bg_color,
    }"
  >
    <a
      class="main-tag"
      :href="getGoLink($root.goto_link, $root.slug)"
      v-if="$root.color_schema.site_bg_img"
      target="_blank"
      :rel="$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'"
    ></a>
    <section
      :class="{
        'ct-search': true,
        'custom-background-color': $root.color_schema.site_bg_img,
      }"
    >
      <div class="container">
        <!--Breadcrumps-->
        <div class="col-md-12">
          <Breadcrumb :breadcrumbData="breadcrumbData" :dark="true" />
        </div>
        <!--End Breadcrumps-->
      </div>

      <div class="container">
        <h2 class="custom-font-1 fw-900">
          {{ $root.i18n.search_results }} / {{ searchText | titleCase }}
        </h2>
        <div class="ct-search-count">
          <span
            >{{ $root.i18n.showing_results }} {{ calcResultCount.firstCount }} -
            {{ calcResultCount.lastCount }} of {{ totalResultsCount }}</span
          >
          <template v-if="pageData.length > 0">
            <span class="ct-search-sort" v-if="sortAsc" @click="sortResult()">
              A
              <i class="fas fa-long-arrow-alt-down"></i>
            </span>
            <span class="ct-search-sort" v-if="!sortAsc" @click="sortResult()">
              Z
              <i class="fas fa-long-arrow-alt-down"></i>
            </span>
          </template>
        </div>
        <div class="ct-search-result">
          <div class="row">
            <div class="col-12" v-for="data in pageData" :key="data.id">
              <div
                class="
                  casino-card casino-card-horizontal casino-card-horizontal__m
                  search-item
                "
              >
                <div class="casino-card-row">
                  <div class="casino-card-row-left mw-80">
                    <div class="card-text casino-card-text">
                      <div
                        class="search-card-title"
                        :style="{
                          '--primary-color-hover':
                            $root.color_schema.primary_btn,
                        }"
                      >
                        <template v-if="$root.enable_piwik_reload">
                          <a
                            :title="data.title"
                            :href="
                              getRouteLink(data.slug, data.type, data.base_slug)
                            "
                            >{{ data.title }}</a
                          >
                        </template>
                        <template v-else>
                          <router-link
                            :title="data.title"
                            :to="
                              getRouteLink(data.slug, data.type, data.base_slug)
                            "
                            >{{ data.title }}</router-link
                          >
                        </template>
                      </div>
                      <div class="search-card-link">
                        <template v-if="$root.enable_piwik_reload">
                          <a
                            :title="data.title"
                            :href="
                              getRouteLink(data.slug, data.type, data.base_slug)
                            "
                            :style="{ color: $root.color_schema.primary_btn }"
                            >{{
                              `${$root.site_url}${getRouteLink(
                                data.slug,
                                data.type,
                                data.base_slug
                              )}`
                            }}</a
                          >
                        </template>
                        <template v-else>
                          <router-link
                            :title="data.title"
                            :to="
                              getRouteLink(data.slug, data.type, data.base_slug)
                            "
                            :style="{ color: $root.color_schema.primary_btn }"
                            >{{
                              `${$root.site_url}${getRouteLink(
                                data.slug,
                                data.type,
                                data.base_slug
                              )}`
                            }}</router-link
                          >
                        </template>
                      </div>
                      <div class="search-card-desc" v-if="data.excerpt">
                        {{ data.excerpt }}
                      </div>
                    </div>
                  </div>
                  <div class="casino-card-row-right">
                    <template v-if="$root.enable_piwik_reload">
                      <a
                        :title="$root.i18n.read_more"
                        :href="
                          getRouteLink(data.slug, data.type, data.base_slug)
                        "
                        :class="{
                          'cta cta-primary cta-promotion mt-0 search-read-btn custom-btn': true,
                          'text-white':
                            !$root.override_ctabtntxt_color &&
                            !getContrastYIQ($root.color_schema.primary_btn),
                          'text-gray':
                            !$root.override_ctabtntxt_color &&
                            getContrastYIQ($root.color_schema.primary_btn),
                          'text-cta-override': $root.override_ctabtntxt_color,
                        }"
                        :style="{
                          '--primary-btn': $root.color_schema.primary_btn,
                          '--primary-btn-hover': pSBC(
                            -0.2,
                            $root.color_schema.primary_btn
                          ),
                        }"
                        >{{ $root.i18n.read_more }}</a
                      >
                    </template>
                    <template v-else>
                      <router-link
                        :title="$root.i18n.read_more"
                        :to="getRouteLink(data.slug, data.type, data.base_slug)"
                        :class="{
                          'cta cta-primary cta-promotion mt-0 search-read-btn custom-btn': true,
                          'text-white':
                            !$root.override_ctabtntxt_color &&
                            !getContrastYIQ($root.color_schema.primary_btn),
                          'text-gray':
                            !$root.override_ctabtntxt_color &&
                            getContrastYIQ($root.color_schema.primary_btn),
                          'text-cta-override': $root.override_ctabtntxt_color,
                        }"
                        :style="{
                          '--primary-btn': $root.color_schema.primary_btn,
                          '--primary-btn-hover': pSBC(
                            -0.2,
                            $root.color_schema.primary_btn
                          ),
                        }"
                        >{{ $root.i18n.read_more }}</router-link
                      >
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pagination-wrap">
          <ul>
            <li>
              <a
                :title="currentPage - 1"
                v-if="currentPage > 1"
                @click="prevPage()"
                class="prev"
                ><img
                  :src="$root.site_url + $root.asset_path + '/p-arrow.svg'"
                  alt=""
              /></a>
            </li>
            <template v-if="paginationNumbers > 6">
              <template v-if="currentPage < paginationNumbers - 6">
                <li
                  v-for="i in getRange(currentPage, 3, paginationNumbers - 3)"
                  :key="i + 'first'"
                >
                  <a
                    :title="currentPage"
                    :class="{ active: i === currentPage }"
                    @click="changePage(i)"
                    >{{ i }}</a
                  >
                </li>
                <li>...</li>
              </template>
              <template v-else>
                <li
                  v-for="i in getRange(
                    paginationNumbers - 6,
                    4,
                    paginationNumbers - 3
                  )"
                  :key="i + 'first'"
                >
                  <a
                    :title="currentPage"
                    :class="{ active: i === currentPage }"
                    @click="changePage(i)"
                    >{{ i }}</a
                  >
                </li>
              </template>
              <li
                v-for="i in getRange(
                  paginationNumbers - 2,
                  3,
                  paginationNumbers
                )"
                :key="i + 'second'"
              >
                <a
                  :title="currentPage"
                  :class="{ active: i === currentPage }"
                  @click="changePage(i)"
                  >{{ i }}</a
                >
              </li>
            </template>
            <template v-else>
              <li
                v-for="(pagination, pageIn) in paginationNumbers"
                :key="pageIn"
              >
                <a
                  :title="currentPage"
                  v-if="
                    paginationNumbers != 0 && currentPage != paginationNumbers
                  "
                  @click="nextPage(pageIn + 1)"
                  :class="{ active: pageIn + 1 === currentPage }"
                  >{{ pageIn + 1 }}</a
                >
              </li>
            </template>
            <li>
              <a
                :title="currentPage + 1"
                v-if="
                  paginationNumbers != 0 && currentPage != paginationNumbers
                "
                @click="nextPage(currentPage + 1)"
                class="next"
                ><img
                  :src="$root.site_url + $root.asset_path + '/p-arrow.svg'"
                  alt=""
              /></a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import Breadcrumb from "@/components/layouts/Breadcrumb";
import { pSBC, getContrastYIQ } from "@/misc/misc-function";
import { HttpService } from "@/api/Pages.api";

export default {
  name: "Search",
  data: function () {
    return {
      searchText: "",
      sortAsc: true,
      totalResultsCount: 0,
      pageData: [],
      currentPage: 1,
      breadcrumbData: [],
      paginationNumbers: 0,
      orderBy: "relevance"
    };
  },
  components: {
    Breadcrumb,
  },
  filters: {
    titleCase: function (value) {
      value = value.trim().toLowerCase();
      return Array.prototype.map
        .call(value, (chr, index) => (index === 0 ? chr.toUpperCase() : chr))
        .join("");
    },
  },
  beforeCreate: function () {
    this.$root.loading = true;
  },
  mounted: function () {
    this.searchResult();
  },
  beforeDestroy: function () {
    this.subscription.unsubscribe();
  },
  watch: {
    "$route.params.searchText": function () {
      this.$root.loading = true;
      this.currentPage = 1;
      this.searchResult();
    },
  },
  methods: {
    pSBC,
    getContrastYIQ,
    searchResult: function () {
      this.searchText = this.$route.params.searchText.trim();
      let sortOrder = this.sortAsc ? "asc" : "desc";
      HttpService.getSearchResult(
        this.$root.wp_country && this.$root.wp_country != ""
          ? this.$root.wp_country
          : this.$cookies.get("wp-country"),
        this.$root.wp_state && this.$root.wp_state != ""
          ? this.$root.wp_state
          : this.$cookies.get("wp-state"),
        this.searchText,
        this.currentPage,
        sortOrder,
        this.$root.user_id,
        this.orderBy
      )
        .then((res) => {
          this.pageData = res.data.data.results;
          this.totalResultsCount = res.data.data.total_results_count;
          this.breadcrumbData = res.data.data.breadcrumb;

          this.paginationNumbers = Math.ceil(
            this.totalResultsCount / res.data.data.query.posts_per_page
          );

          // Adminbar Data
          this.$root.adminBarData =
            Object.keys(res.data.data.toolbar).length > 0
              ? res.data.data.toolbar
              : "";
          this.$root.disable = this.$root.adminBarData
            ? this.$root.adminBarData.visible
            : false;
          this.$root.loading = false;
          this.$root.show_footer = true;
          this.$root.body_loading_status = true;
        })
        .catch((err) => console.log(err));
    },
    nextPage: function () {
      ++this.currentPage;
      this.$root.loading = true;
      this.searchResult();
    },
    prevPage: function () {
      this.currentPage--;
      this.$root.loading = true;
      this.searchResult();
    },
    changePage: function (i) {
      this.currentPage = i;
      this.$root.loading = true;
      this.searchResult();
    },
    getRange: function (start, end, range) {
      let arr = new Array(range).fill().map((val, index) => index + 1);
      return arr.filter((val) => val >= start && val < start + end);
    },
    sortResult: function () {
      this.sortAsc = !this.sortAsc;
      this.orderBy = "title";
      this.$root.loading = true;
      this.searchResult();
    },
  },
  computed: {
    totalPages: function () {
      if (this.totalResultsCount % 10 != 0) {
        return Math.floor(this.totalResultsCount / 10 + 1);
      } else {
        return Math.round(this.totalResultsCount / 10);
      }
    },
    calcResultCount: function () {
      let firstCount = 1;
      let lastCount = 10;
      if (this.totalResultsCount > 0) {
        if (this.currentPage > 1) {
          firstCount += (this.currentPage - 1) * 10;
          lastCount = this.currentPage * 10;
        }
        if (lastCount > this.totalResultsCount) {
          lastCount = this.totalResultsCount;
        }
      } else {
        firstCount = 0;
        lastCount = 0;
      }
      return { firstCount, lastCount };
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.ct-search {
  padding: 37px 0 25px 0;
  &-sort {
    cursor: pointer;
  }
  &-count {
    display: flex;
    justify-content: space-between;
    font-weight: 700;
    font-size: 0.75rem;
  }
  &-result {
    padding: 0rem;
    padding-bottom: 0.75rem;
    ul {
      li {
        padding: 0.75rem 0;
        cursor: pointer;
        &:not(:last-child) {
          border-bottom: 1px solid #ccc;
        }
      }
    }
    @media (min-width: @sizes[medium]) {
      padding: 0rem;
    }
  }
  &-pagination {
    display: flex;
    justify-content: center;
    padding-top: 20px;
    .page {
      height: auto;
      display: inline-block;
      text-align: center;
      width: 24px;
      border-radius: 8px;
      font-size: 1rem;
      background: #070438;
      color: #ffffff;
      cursor: pointer;
      &:not(:first-child) {
        margin-left: 10px;
      }
    }
    .active {
      background: #ff0000;
    }
  }
}

.next-prev-page {
  font-size: 1rem;
  cursor: pointer;
}

.search {
  &-item {
    padding: 15px;
    @media (min-width: @sizes[medium]) {
      padding: 22px 28px;
    }
  }
  &-card-link {
    a {
      text-decoration: underline;
      font-size: 14px;
      overflow-wrap: anywhere;
      @media (min-width: @sizes[medium]) {
        font-size: 160%;
      }
    }
  }
  &-card-title {
    font-size: 1rem;
    margin-bottom: 9px;
    font-weight: 900;
    @media (min-width: @sizes[medium]) {
      font-size: 1.4rem;
    }
    &:hover {
      color: var(--primary-color-hover);
    }
  }
  &-card-desc {
    font-size: 1rem;
  }
  &-read-btn {
    max-width: 100%;
    width: 100%;
    @media (min-width: @sizes[medium]) {
      max-width: 180px;
      width: 180px;
    }
  }
}

.mt-0 {
  margin-top: 0 !important;
}

.mw-80 {
  max-width: 100% !important;
  @media (min-width: @sizes[medium]) {
    max-width: 80% !important;
  }
}

.fw-900 {
  font-weight: 900 !important;
}

.seperator {
  padding: 0px 4px;
}

.pagination-wrap {
  .display-flex();
  .align-items(center);
  .justify-content-center();
  margin-top: 40px;
  @media (min-width: @sizes[medium]) {
    margin-top: 16px;
  }
  ul {
    .display-flex();
    .align-items(center);
    li {
      cursor: pointer;
      @media (min-width: @sizes[medium]) {
        margin: 0 6px;
      }
      a {
        .display-flex();
        .align-items(center);
        .justify-content-center();
        border: 2px solid transparent;
        .border-radius(3px);
        font-family: Helvetica;
        font-weight: normal;
        font-size: 16px;
        line-height: 26px;
        color: #bdbdbe;
        width: 34px;
        height: 34px;
        &.prev,
        &.next {
          img {
            -webkit-filter: grayscale(1) invert(1);
            filter: grayscale(1) invert(1);
          }
        }
        &.prev {
          img {
            -webkit-transform: rotate(180deg);
            -ms-transform: rotate(180deg);
            transform: rotate(180deg);
          }
        }
        &.active {
          border-color: #264860;
          color: #264860;
        }
      }
      &:hover,
      &.active {
        a {
          border-color: #264860;
          color: #264860;
          &.prev,
          &.next {
            border-color: transparent;
            img {
              -webkit-filter: grayscale(0) invert(0);
              filter: grayscale(0) invert(0);
            }
          }
        }
      }
    }
  }
}
.card-text {
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/Search/Search.vue